import { reportDefinitionParameterService } from '_services';
import ACTIONS_REPORT_DEFINITION_PARAMETER from '_constants/reportDefinitionParameter.constants';
import alertActions from './alert.actions';

export const receiveReportDefinitionParameters = (reportDefinitionParameters) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < reportDefinitionParameters.length; i++) {
    byIdObjectToDispatch[reportDefinitionParameters[i].reportDefinitionParameterID] = reportDefinitionParameters[i];
  }

  return {
    type: ACTIONS_REPORT_DEFINITION_PARAMETER.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteReportDefinitionParameter = (reportDefinitionParameterID) => ({
  type: ACTIONS_REPORT_DEFINITION_PARAMETER.DELETE,
  byId: { [reportDefinitionParameterID]: null }
});

const searchReportDefinitionParameters = ({ reportDefinitionID }) => async (dispatch) => {
  try {
    const resp = await reportDefinitionParameterService.search({ reportDefinitionID });
    if (resp?.reportDefinitionParameters) {
      dispatch(receiveReportDefinitionParameters(resp.reportDefinitionParameters));
      return resp.reportDefinitionParameters;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error searching report parameters.'));
  }
  return null;
};

const getReportDefinitionParameter = (reportDefinitionParameterID) => async (dispatch) => {
  try {
    const resp = await reportDefinitionParameterService.getById(reportDefinitionParameterID);
    if (resp?.reportDefinitionParameter) {
      dispatch(receiveReportDefinitionParameters([ resp.reportDefinitionParameter ]));
      return resp.reportDefinitionParameter;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error retrieving report parameter: ${reportDefinitionParameterID}.`));
  }
  return null;
};

const addReportDefinitionParameter = (reportDefinitionParameter) => async (dispatch) => {
  try {
    const resp = await reportDefinitionParameterService.create({ reportDefinitionParameter });
    if (resp?.reportDefinitionParameter) {
      dispatch(receiveReportDefinitionParameters([ resp.reportDefinitionParameter ]));
      return resp.reportDefinitionParameter;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error creating report parameter.'));
  }
  return null;
};

const updReportDefinitionParameter = (reportDefinitionParameter) => async (dispatch) => {
  try {
    const resp = await reportDefinitionParameterService.update({ reportDefinitionParameter });
    if (resp?.reportDefinitionParameterUpdated) {
      dispatch(receiveReportDefinitionParameters([ resp.reportDefinitionParameterUpdated ]));
      return resp.reportDefinitionParameterUpdated;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error updating report parameter.'));
  }
  return null;
};

const delReportDefinitionParameter = (reportDefinitionParameterID) => async (dispatch) => {
  try {
    const resp = await reportDefinitionParameterService.delete(reportDefinitionParameterID);
    if (resp?.reportDefinitionParameter) {
      dispatch(deleteReportDefinitionParameter(resp.reportDefinitionParameter.reportDefinitionParameterID));
      return resp.reportDefinitionParameter;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error removing report parameter: ${reportDefinitionParameterID}.`));
  }
  return null;
};

const reportDefinitionParameterActions = {
  searchReportDefinitionParameters,
  getReportDefinitionParameter,
  addReportDefinitionParameter,
  updReportDefinitionParameter,
  delReportDefinitionParameter
};

export default reportDefinitionParameterActions;
